import type { Identifiable } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingState } from '../../../models'
import type { CrudServiceProvider } from '../../../providers/interfaces'
import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { CRUD_CONSTS } from '../../crud/crud.consts'
import { TOOLING_CONSTS } from '../tooling.consts'

export class DeleteAction implements ActionClass {
  static async execute(
    this: void,
    { state, commit, dispatch }: ActionContext<ToolingState, unknown>,
    { tool, items: itemsToDelete }: { tool: string; items: Array<Identifiable<string | number>> },
  ): Promise<void> {
    const service = CONTAINER.get<CrudServiceProvider>(TYPES.CrudServiceProvider)(tool)
    const responses = await Promise.allSettled(
      itemsToDelete.map(itemToDelete => service.delete(itemToDelete)),
    )
    let { results, numFound } = state.tools[tool]?.data ?? { results: [], numFound: 0 }
    let updateState = false
    const deletedIds: Array<unknown> = []
    const errors: Array<unknown> = []
    responses.forEach((response, index) => {
      if (response.status === 'fulfilled') {
        const id = itemsToDelete[index].id
        const itemIndex = results.findIndex(result => result.id === id)
        if (itemIndex >= 0) {
          results = [...results]
          results.splice(itemIndex, 1)
          numFound--
          if (!updateState) {
            updateState = true
          }
        }
        deletedIds.push(id)
      } else {
        errors.push(response.reason)
      }
    })
    if (deletedIds.length) {
      if (updateState) {
        commit(TOOLING_CONSTS.mutations.setState, {
          [tool]: {
            data: {
              results,
              numFound,
            },
          },
        })
      }
      await dispatch(
        `${CRUD_CONSTS.moduleName}/${CRUD_CONSTS.actions.tag}`,
        {
          featureId: tool,
          type: EngagementActionsTypeEnum.DELETE,
        },
        { root: true },
      )
    }
    if (errors.length) {
      throw errors
    }
  }
}
